import AdminPropertyReviewTable from './AdminPropertyReviewTable';

const PropertiesInReview = () => (
  <AdminPropertyReviewTable
    filterStatus="under_review"
    title="عقارات تحت المراجعة"
    subtitle="راجع العقارات المقدمة ووافِ على كل منها أو ارفضه"
  />
);

export default PropertiesInReview;
